import React, { useEffect } from 'react'
import styled from 'styled-components'
import ArrowLeftIcon from '@8x8/oxygen-icon/novo/ArrowLeftIcon'

import { FlexCentered } from '~/components/common/containers'

const Button = styled(FlexCentered)`
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  justify-content: center;
  padding: 12px 8px;
  position: absolute;
  top: calc(50% - 20px);
  transition: 0.2s;

  &:hover {
    background: #1C2025;
  }
`

const PrevButton = styled(Button)`
  border-radius: 0px 4px 4px 0px;
  left: 0;
`

const NextButton = styled(Button)`
  border-radius: 4px 0px 0px 4px;
  right: 0;
`

const ArrowRightIcon = styled(ArrowLeftIcon)`
  transform: rotate(180deg);
`
const SlideshowNavigationControls = ({
  hasMore,
  onNext,
  onPrevious,
  selectedSlide,
  slides
}) => {
  const index = slides.indexOf(selectedSlide)
  const isLastSlide = index === slides.length - 1 && !hasMore
  const isFirstSlide = index === 0

  const handleKeydown = (event) => {
    switch (event.code) {
      case 'ArrowLeft':
        onPrevious()
        break
      case 'ArrowRight':
        onNext()
        break
      default:
        break
    }
  }
  useEffect(() => {
    window.addEventListener('keydown', handleKeydown)
    return () => window.removeEventListener('keydown', handleKeydown)
  })

  return (
    <>
      {!isLastSlide &&
        <NextButton onClick={onNext}>
          <ArrowRightIcon color='white' />
        </NextButton>}
      {!isFirstSlide &&
        <PrevButton onClick={onPrevious}>
          <ArrowLeftIcon color='white' />
        </PrevButton>}
    </>
  )
}

export default SlideshowNavigationControls
